
/**
 * Transforms inventory data into a normalized structure grouped by product and lot.
 *
 */
export function transformData(inventory = [], productNames = []) {
    console.log('productNames', productNames)

    const transformedData = []

    for (const productInventory of inventory) {
        const { preferenceCardName, wasFound, quantity, hasPreferenceCard } = productInventory

        let updatedProductStructure = {
            preferenceCardName,
            wasFound,
            hasPreferenceCard,
            quantity,
            kits: []
        }

        if (wasFound === false) {
            transformedData.push(updatedProductStructure)
            continue
        }



        for (const [index, kit] of productInventory.inventoryProducts?.entries?.() ?? []) {
            const { productName, inventoryProductId, quantity } = kit

            const updatedKitStructure = {
                productName,
                inventoryProductId,
                quantity,
                maxQuantity: quantity,
                key: index,
                lots: []
            }

            for (const lot of kit.groupedInventoriesByLotNumbers) {
                const { lotNumber, quantity, inventoryId, facilityProductId } = lot
                updatedKitStructure.lots.push({
                    lotNumber,
                    inventoryId,
                    quantity,
                    maxQuantity: quantity,
                    facilityProductId
                })
            }

            updatedProductStructure.kits.push(updatedKitStructure)
        }

        transformedData.push(updatedProductStructure)
    }

    // 🔥 Sort by productNames order
    const orderMap = new Map(productNames.map((name, i) => [name, i]))

    transformedData.sort((a, b) => {
        const indexA = orderMap.get(a.preferenceCardName)
        const indexB = orderMap.get(b.preferenceCardName)

        // Items not found in productNames go to the end
        if (indexA === undefined) return 1
        if (indexB === undefined) return -1

        return indexA - indexB
    })

    console.log('transformedData', transformedData)
    return transformedData
}


export function getSubmittableData(formsData) {
    return formsData
        // take only items that actually have transactions
        .flatMap(item => item.transactions || [])
        // keep only valid inventory records
        .filter(kit => kit.inventoryId && kit.facilityProductId && kit.quantity > 0 && kit.lotNumber !== null && kit.lotNumber !== undefined)
        // map to required shape
        .map(kit => ({
            inventoryId: kit.inventoryId,
            quantity: kit.quantity,
            facilityProductId: kit.facilityProductId,
            lotNumber: kit.lotNumber ?? "",
            comment: kit.comment ? `${kit.comment}` : undefined,
        })); 
}

export function filterInventoryKits(kit, submittedKits, isInventorySubmitted){
    console.log('kit', kit, submittedKits, isInventorySubmitted)
    if(isInventorySubmitted === false) return true;
    else{
        const lots = kit.lots || []
       // check if there exists a lot
    }

}